module.exports = __webpack_public_path__ + "static/media/dj_noroc.de4c3588.jpg";